import { jsx, jsxs } from "react/jsx-runtime";
import { CalendarIcon } from "@dion-web/ui-icons";
import { LocalizationProvider as LocalizationProviderMui } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useMemo } from "react";
import { notReachable } from "../../shared/helpers";
import { dayjs } from "../../shared/libs";
import { DatePickerStyled } from "./ui";
import { Typography, Stack, Icon } from "../../components";
import { useDateCalendarSlots, CALENDAR_VIEW } from "../DateCalendar/shared";
dayjs.updateLocale("en", {
  // Sunday = 0, Monday = 1.
  weekStart: 1
});
const DatePicker = ({
  locale = "ru",
  className,
  header = "",
  type = "single-date",
  isTextField = true,
  ...props
}) => {
  const viewsProps = [CALENDAR_VIEW.year, CALENDAR_VIEW.month, CALENDAR_VIEW.day];
  const { calendarPickerSlots, calendarPickerSlotsProps } = useDateCalendarSlots(type, props);
  const datePickerSlots = React.useMemo(() => {
    return {
      openPickerIcon: () => /* @__PURE__ */ jsx(Icon, { size: "l", icon: /* @__PURE__ */ jsx(CalendarIcon, {}) }),
      ...calendarPickerSlots
    };
  }, [type, calendarPickerSlots]);
  const datePickerSlotsProps = React.useMemo(() => {
    if (type === "single-date")
      return {
        textField: { placeholder: "__.__.____", "data-testid": "date" },
        openPickerButton: { "data-testid": "arrow-select-date" },
        ...calendarPickerSlotsProps
      };
    if (type === "week-date")
      return {
        ...calendarPickerSlotsProps
      };
    return {};
  }, [type, calendarPickerSlotsProps]);
  const renderDatePicker = useMemo(
    () => {
      switch (type) {
        case "single-date":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && isTextField && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: "8px", children: header }),
            /* @__PURE__ */ jsx(
              DatePickerStyled,
              {
                $type: type,
                $isTextField: isTextField,
                views: viewsProps,
                label: "",
                format: "DD.MM.YYYY",
                ampm: false,
                showDaysOutsideCurrentMonth: true,
                ...props,
                slots: datePickerSlots,
                slotProps: datePickerSlotsProps
              }
            )
          ] });
        case "week-date":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && /* @__PURE__ */ jsx(Typography, { marginBottom: 1, children: header }),
            /* @__PURE__ */ jsx(
              DatePickerStyled,
              {
                $type: type,
                $isTextField: isTextField,
                views: viewsProps,
                label: "",
                format: "DD.MM.YYYY",
                ampm: false,
                showDaysOutsideCurrentMonth: true,
                ...props,
                slots: datePickerSlots,
                slotProps: datePickerSlotsProps
              }
            )
          ] });
        default:
          notReachable(type);
      }
    },
    [type, isTextField, locale, header, props]
  );
  return /* @__PURE__ */ jsx(
    LocalizationProviderMui,
    {
      dateAdapter: AdapterDayjs,
      adapterLocale: locale,
      children: renderDatePicker
    }
  );
};
DatePicker.displayName = "DatePicker";
var DatePicker_default = DatePicker;
export {
  DatePicker_default as default
};
